import localStorage from "legacy/utils/localStorage";

// The editor writes copied blocks under this key; logging out here clears them.
const COPY_PASTE_API_DSL_STORAGE_KEY = "superblocks-copy-paste-api-dsl";

export const clearCopiedBlocksFromLocalStorage = () => {
  localStorage.removeItem(COPY_PASTE_API_DSL_STORAGE_KEY);
};
